import angular from 'angular'
import errorDelegationService from './error.delegation.service'

export default angular
  .module('ellipsis.errors', [])
  .service('errorDelegationService', errorDelegationService)
